import React from "react"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import { Slider, Select, Button, Col, Row } from "antd"

import BankCard from "./BankCard"
import All from "./All"
import { handleOnSuccess, addBank } from "./actions"
import onMount from "../../core/onMount"

const mapDispatchToProps = dispatch => {
  return {
    handleOnSuccess: (public_token, metadata) =>
      dispatch(handleOnSuccess(public_token, metadata)),
    onClick: token_id => dispatch(push("bank-card/" + token_id)),
    addBank: () => dispatch(addBank())
  }
}

const mapStateToProps = ({
  models: {
    user: { bankAccounts, bankNames, institution_users }
  }
}) => {
  return {
    bankAccounts,
    bankNames,
    institution_users
  }
}

export default props => (
  <Switch>
    <Route
      exact
      path={`/account/bank-card`}
      component={connect(
        mapStateToProps,
        mapDispatchToProps
      )(All)}
    />

    <Route path={`/account/bank-card/:tokenId`} component={BankCard} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/account/bank-card/index.js